export class AbstractEditorController {
    constructor($http, $state, $stateParams, Alert, growl, NavHelper) {
        this.api = $http;
        this.state = $state;
        this.stateParams = $stateParams;
        this.alert = Alert;
        this.growl = growl;
        this.navHelper = NavHelper;

        this.currentActiveType = null;
        this.availableTypes = [];
        this.typeSelectionDisabled = false;

        this.headline = 'Edit Bookable-object';
    }

    _loadObject() {
        return this.api.get(`bo/objects/${this.stateParams.id}`).then((response) => {
            this.model = this._prepareModelFromApi(response.data.data);
            this.navHelper.setTranslationsParamsForEntry('settings.custom_defaults.bo-objects.details.main', {
                name: this.model.label
            });
        }, () => {
            this.alert.error('Error', 'Error while loading bookable object');
            this.state.back();
        });
    }

    _loadAvailableTypes() {
        return this.api.get(`bo/objects/types`).then((response) => {
            this.availableTypes = response.data.data;
            this._updateCurrentActiveType(true);
        }, () => {
            this.alert.error('Error', 'Error while loading available types. Please try again.');
            this.state.back();
        });
    }

    _updateCurrentActiveType(noMetaReset) {
        if (!this.model || !this.model.type || this.availableTypes.length === 0) {
            return;
        }

        _.each(this.availableTypes, (typeInfo) => {
            if (typeInfo.key === this.model.type) {
                this.currentActiveType = _.cloneDeep(typeInfo);
            }
        });

        if (!noMetaReset) {
            this.model.meta = {};
            _.each(this.currentActiveType.meta, (metaDef) => {
                let defaultVal = null;
                switch (metaDef.type) {
                    case 'string':
                        defaultVal = '';
                        break;
                    case 'bool':
                        defaultVal = false;
                        break;
                    case 'int':
                    case 'number':
                        defaultVal = '';
                        break;
                    case 'custom_definition':
                        defaultVal = {};
                        break;
                }
                this.model.meta[metaDef.key] = defaultVal;
            });
        }
    }

    _prepareModelForApi() {
        const data = _.cloneDeep(this.model);

        _.each(this.currentActiveType.meta, (metaDef) => {
            const metaValue = _.get(data.meta, metaDef.key);
            if (metaValue
                && metaDef.key.startsWith('option_custom_')
                && metaDef.key.endsWith('_definition')
                && !metaValue.type
                && !metaDef.required) {
                delete data.meta[metaDef.key];
            }
        });

        return data;
    }

    _prepareModelFromApi(apiData) {
        const out = _.cloneDeep(apiData),
            oldMeta = out.meta;

        delete out.meta;
        out.meta = {};
        _.each(oldMeta, (metaInfo) => {
            out.meta[metaInfo.key] = metaInfo.value;
        });

        return out;
    }

    updateSelectedType(newValue) {
        this.model.type = newValue;
        this._updateCurrentActiveType();
    }

    updateMetaValue(newValue, metaField) {
        this.model.meta[metaField] = newValue;
    }
}

AbstractEditorController.$inject = [
    '$http',
    '$state',
    '$stateParams',
    'Alert',
    'growl',
    'NavHelper'
];



// WEBPACK FOOTER //
// ./src/app/modules/bo/objects/controllers/abstract-editor-controller.js